import React from 'react';
import QuotesSection from '../../../sections/AdminDashboard/Quotes/Quotes';

const Quotes = () => {
  return <QuotesSection />;
};

export default Quotes;
